import { combineReducers } from "redux";

import CurrentContractorReducer from "./currentContractorReducer";
import OnboardingReducer from "./onboardingReducer";
import CurrentlyClaimedCallsReducer from "./onboardingReducer";
import TranscriptionReducer from "./transcriptionReducer";
import TranscriptionQualityRatingReducer from "./transcriptionQualityRatingReducer";
import QaSuperUserReducer from "./qaSuperUserReducer";
import SegmentsReducer from "./segmentsReducer";
import LocalReducer from "./localReducer";
import HomeReducer from "./homeReducer";

const RootReducer = combineReducers({
  onboarding: OnboardingReducer,
  currentContractor: CurrentContractorReducer,
  home: HomeReducer,
  currentlyClaimedCalls: CurrentlyClaimedCallsReducer,
  is_tqr_onboarding: (state = {}) => state,
  transcription: TranscriptionReducer,
  transcriptionQualityRating: TranscriptionQualityRatingReducer,
  qaSuperUser: QaSuperUserReducer,
  segments: SegmentsReducer,
  local: LocalReducer,
  applicantEmail: (state = {}) => state,
});

export default RootReducer;
